import React from 'react';
import PropTypes from 'prop-types';
import { SingleFileUpload } from 'components/form/upload';
import { FormItem, Input } from 'formik-antd';
import { getUrlFromEvent } from 'utils/form';
import StagePropTypes from '../prop-types';

import './style.css';

const getFile = (path, values) => {
  if (!values[path]) return null;
  if (!values[path].fileURL) return null;
  return values[path].fileURL;
};

const CourseInput = ({
  label,
  showLabel,
  name,
  isSubmitting,
  setFieldValue,
  values,
  uploadTo,
  dbPrefix,
}) => {
  const prefix = `${dbPrefix}.${name}`;

  const file = getFile(name, values[dbPrefix])
    ? {
        name: `${prefix}.fileURL`,
        url: values[dbPrefix][name].fileURL,
      }
    : undefined;

  return (
    <>
      {label ? (
        showLabel && <h3>{label}</h3>
      ) : (
        <FormItem name={`${prefix}.name`}>
          <Input placeholder="Name of course" name={`${prefix}.name`} />
        </FormItem>
      )}

      <FormItem name={`${prefix}.fileURL`}>
        <SingleFileUpload
          className="ant-upload ant-upload-drag"
          title={label}
          subTitle="Click in this area to upload"
          file={file}
          uploadTo={uploadTo}
          multiple={false}
          showUploadList
          disabled={file != null || isSubmitting}
          onClear={() => {
            setFieldValue(`${prefix}.fileURL`, null);
          }}
          onChange={(e) => {
            setFieldValue(`${prefix}.fileURL`, getUrlFromEvent(e));
          }}
        />
      </FormItem>
    </>
  );
};

CourseInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  showLabel: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
  uploadTo: PropTypes.string.isRequired,
  dbPrefix: PropTypes.string.isRequired,
};

CourseInput.defaultProps = {
  label: '',
  showLabel: false,
};

export default CourseInput;
